import React from 'react';
import clsx from 'clsx';
import GroupContractPriceBuilder from '../GroupContractPriceBuilder';
import AddButtonNew from '../../AddButton/AddButtonNew';
import GroupContractBuilderErrors from '../GroupContractBuilderErrors';

class GroupContractBuilderPricing extends React.Component {

  constructor(props) {
    super(props);

    this.onAddGroupContractPrice = this.onAddGroupContractPrice.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onRemoveGroupContractPrice = this.onRemoveGroupContractPrice.bind(this);    
  }



  /*******************
  * Render functions *
  ********************/

  render() {
    var self = this;
    var tabClasses = clsx({
      'active': this.props.active_tab == 'pricing',
      'tab-pane': true
    });

    var group_contract_price_index = 0;
    var group_contract_prices = this.props.group_contract_prices.map((group_contract_price) => {
      return <GroupContractPriceBuilder 
                key={group_contract_price.id} 
                {...group_contract_price} 
                onChange={self.onChange}
                onRemove={self.onRemoveGroupContractPrice} 
                index={group_contract_price_index++} 
                nested={true} 
                read_only={self.props.read_only}
                date_format={self.props.date_format} 
                time_format={self.props.date_format} 
                view_type="room_type_price"
              />;
    });

    return (
      <div className={tabClasses} id="pricing">

        {this.renderErrors()}
        {this.renderPrintButton()}

        <div className="row">
          <div className="col-md-12">
              
            <div className="panel panel-default" style={{marginBottom: 0}}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6">
                <h3 className="panel-title">
                  {I18n.t('group_contract_prices')} <span className="ss-help help" title={I18n.t('group_contract_prices_helper_text')}></span>
                </h3>
                </div>
                <div className="col-md-6 content-right flexed">
                  {
                    this.props.read_only
                    ?
                    null
                    :
                    <AddButtonNew
                      disabled={this.props.disabled} 
                      new_button={false} 
                      model="RoomType" 
                      text={I18n.t('add')}
                      ids={this.props.group_contract_prices ? this.props.group_contract_prices.map((group_contract_price) => { return group_contract_price.room_type_id; }) : null} 
                      onAdd={self.onAddGroupContractPrice}
                      view_type="room_type_price"
                      buttonClasses="btn btn-secondary"
                      generalPosition="left"
                    />
                    // <AddButton 
                    //   disabled={this.props.disabled} 
                    //   new_button={false} 
                    //   model="RoomType" 
                    //   text={I18n.t('add')}
                    //   ids={this.props.group_contract_prices ? this.props.group_contract_prices.map((group_contract_price) => { return group_contract_price.room_type_id; }) : null} 
                    //   onAdd={self.onAddGroupContractPrice}
                    //   view_type="room_type_price"
                    //   buttonClasses="btn btn-secondary"
                    // />
                  }
                </div>
              </div>
              <div className="panel-body">
                <div className="group-contract-prices">
                  {group_contract_prices.length ? group_contract_prices : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>}
                </div>
              </div>
            </div>
            
          </div>
        </div>

      </div>  
    );
  }

  renderErrors() {
    var errors = GroupContractBuilderErrors.pricing(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderPrintButton() {
    if (this.props.print_button) {
      return (
        <div className="print-new-window" style={{position: 'absolute', top: -5, right: 0}}>
          <button className="btn btn-dark" title={I18n.t('print')}><span className="ss-print"></span></button>
        </div>
      );
    } else {
      return null;
    }
  }



  /**
  * Change handlers
  */

  onAddGroupContractPrice(room_type) {
    var group_contract_prices = this.props.group_contract_prices.slice(0);
    var group_contract_price = {
      id: this.generateId(),
      room_type: room_type,
      room_type_id: room_type ? room_type.id : '-0',
      room_type_price: room_type.room_type_price,
      room_type_price_id: room_type.room_type_price_id,
    };  
    group_contract_prices.unshift(group_contract_price);
    this.onChangeGroupContractPrices(group_contract_prices);
  } 

  onChange(group_contract_price) {
    var group_contract_prices = this.props.group_contract_prices.slice(0);
    var idx = this.getGroupContractPriceIndexById(group_contract_price.id);
    //console.log('onChange group_contract_price', group_contract_price, idx);
    group_contract_price.group_contract_id = this.props.group_contract_id;
    group_contract_prices[idx] = group_contract_price;
    this.onChangeGroupContractPrices(group_contract_prices);
  }

  onChangeGroupContractPrices(group_contract_prices) {
    this.props.onChange({
      target: {
        name: 'group_contract_prices',
        value: group_contract_prices
      }
    });
  }

  onRemoveGroupContractPrice(group_contract_price_id) {
    var group_contract_prices = this.props.group_contract_prices.slice(0);
    var idx = this.getGroupContractPriceIndexById(group_contract_price_id);
    if (idx >= 0) {
      group_contract_prices.splice(idx, 1);
      this.onChangeGroupContractPrices(group_contract_prices);
    }
  }



  /**********
  * Helpers *
  ***********/


  getGroupContractPriceIndexById(id) {
    for (var i = 0, ilen = this.props.group_contract_prices.length; i < ilen; i++) {
      if (this.props.group_contract_prices[i].id == id) {
        return i;
      }
    }
  }

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return '-' + text;
  }
};
export default GroupContractBuilderPricing